const VERSION = '2.0.11p'
export default VERSION
